export default __webpack_public_path__ + "static/media/lakeroad.285e4bf7.png";